import React from "react";

const NewsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
    >
      <path
        d="M24.0833 3.5L5.41659 3.5C4.12159 3.5 3.08325 4.53833 3.08325 5.83333L3.08325 22.1667C3.08325 23.4617 4.12159 24.5 5.41659 24.5H24.0833C25.3783 24.5 26.4166 23.4617 26.4166 22.1667V5.83333C26.4166 4.53833 25.3783 3.5 24.0833 3.5ZM6.58325 8.16667H12.4166V15.1667H6.58325V8.16667ZM22.9166 19.8333H6.58325V17.5H22.9166V19.8333ZM22.9166 15.1667H14.7499V12.8333H22.9166V15.1667ZM22.9166 10.5H14.7499V8.16667H22.9166V10.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default NewsIcon;
